export default forgotPasswordCtrl

/** @ngInject */
function forgotPasswordCtrl($scope, $state, $stateParams, User, ApiService, ContactTelephone, ErrorCatcher) {
    $scope.contactTelephone = ContactTelephone
    $scope.user = {}
    $scope.fromCommunity = $stateParams.source === 'communaute'
    $scope.source = $stateParams.source
    $scope.redirectTo = $stateParams.redirectTo
    ApiService.resetPromise('userInfo')
    $scope.sendResetPasswd = false
    $scope.sendResetPasswdSuccess = false
    $scope.incorrectEmail = false
    $scope.unknownError = false
    $scope.isForgotPassword = false
    $scope.page = $state.current.name

    $scope.sendResetPassword = function (user) {
        $scope.isForgotPassword = true
        return User.resetPassword({ email: user.username }).$promise
        .then((() => {
            $scope.loginError = false
            $scope.sendResetPasswd = true
            $scope.sendResetPasswdSuccess = true
        }), ((error) => {
            $scope.loginError = false
            $scope.sendResetPasswd = true
            if (error.status === 400) {
                $scope.incorrectEmail = true
            } else {
                $scope.unknownError = true
            }
            return ErrorCatcher.catchError(error)
        })).finally(() => {
            $scope.isForgotPassword = false
        })
    }
}



// WEBPACK FOOTER //
// ./src/states/forgotPassword/forgotPassword.js